import { render, staticRenderFns } from "./SidePanelNewUser.vue?vue&type=template&id=5e7a3656&scoped=true&"
import script from "./SidePanelNewUser.vue?vue&type=script&lang=js&"
export * from "./SidePanelNewUser.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelNewUser.vue?vue&type=style&index=0&id=5e7a3656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a3656",
  null
  
)

export default component.exports